const GENRE_OPTIONS = [
  { value: 'male', text: 'Male' },
  { value: 'female', text: 'Female' },
];

const USER_TYPES = {
  PARENT: 'parent',
  CHILD: 'child',
};

export { GENRE_OPTIONS, USER_TYPES };
